// extracted by mini-css-extract-plugin
export default {"noizeMeter":"NoizeMeter_noizeMeter__wpEGc","noizeGrafWrapper":"NoizeMeter_noizeGrafWrapper__wjtGz","newRecordBlock":"NoizeMeter_newRecordBlock__ShpnH"};